export default class MainPageService {
    private static desktopSmMaxValue: number = 1679;

    /**
     * Конвертация px в формате vw resize
     * @public
     * @static
     */
    public static convertVwToPx(target: number): number {
        const vwContext: number = 1680 * 0.01;
        return (target / vwContext) * (window.innerWidth / 100);
    }

    public static getConvertedValue(value: number): number {
        return this.isSmallDesktop ? this.convertVwToPx(value) : value;
    }

    /**
     * Проверка размера экрана на то, что он меньше 1680px
     * @public
     * @static
     */
    public static isSmallDesktop(): boolean {
        return window.innerWidth <= this.desktopSmMaxValue;
    }
}
